'use client';

import { useEffect } from 'react';
import { registerOptOutCookieSweep } from '@/libs/oneTrust/cookieDeletion';

/**
 * Registers the opt-out cookie sweep with the OneTrust dispatcher on mount.
 * Renders nothing — exists solely to bridge the client-only registration into
 * the server-component OneTrust tree.
 */
export function OneTrustCookieSweep() {
  useEffect(() => registerOptOutCookieSweep(), []);
  return null;
}
